import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
    selector: '[NoDecimal]',
    standalone: true
})
export class NoDecimalDirective {

    constructor(private el: ElementRef) {
    }

    @HostListener('keypress', ['$event']) onKeyPress(event:KeyboardEvent) {
        let e = <KeyboardEvent> event;
        return e.charCode >= 48 && e.charCode <= 57;
    }

}
